import { themeStyle } from "../../components/Components";
import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import PublicIcon from "@mui/icons-material/Public";
import { Line } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import GavelIcon from "@mui/icons-material/Gavel";
import BallotIcon from "@mui/icons-material/Ballot";
import ComputerIcon from "@mui/icons-material/Computer";
import HistoryIcon from "@mui/icons-material/History";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import CalendarPicker from "@mui/lab/CalendarPicker";
import CalculateIcon from "@mui/icons-material/Calculate";
import { Chart } from "chart.js/auto";
import endOfWeek from "date-fns/endOfWeek";
import isSameDay from "date-fns/isSameDay";
import isWithinInterval from "date-fns/isWithinInterval";
import startOfWeek from "date-fns/startOfWeek";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

// import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import Calendar from "react-calendar";
import moment from "moment";
import { CardActionArea } from "@mui/material";

const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function getIcon(subject) {
  var sub = subject.toLowerCase();
  if (
    sub.includes("break") ||
    sub.includes("lunch") ||
    sub.includes("recess")
  ) {
    return <LocalDiningIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("mechanic")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("social")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("civics")) {
    return <GavelIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("polit")) {
    return <BallotIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("compu")) {
    return <ComputerIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("bio")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("chem") || sub.includes("scien")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("economics") ||
    sub.includes("accou") ||
    sub.includes("busi")
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("geom") ||
    sub.includes("archi") ||
    (sub.includes("engg") && sub.includes("draw"))
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("geo")) {
    return <PublicIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("math")) {
    return <CalculateIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("history")) {
    return <HistoryIcon style={{ fontSize: 45, color: "black" }} />;
  } else {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  }
}

const colorList = [
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
];
const colorList2 = [
  "#2ca25f", // Green
  "#8856a7", // Purple
  "#e34a33", // Red
  "#1c9099", // Teal
  "#c51b8a", // Pink
  "#756bb1", // Lavender
  "#fd8d3c", // Light Orange
  "#6baed6", // Light Blue
  "#9e9ac8", // Light Purple
  "#a1d99b", // Mint Green
  "#bcbddc", // Pale Lavender
  "#f768a1", // Hot Pink
  "#7fcdbb", // Aqua
  "#253494", // Navy Blue
];

const colorList3 = [
  "#99d8c9",
  "#9ebcda",
  "#fdbb84",
  "#a6bddb",
  "#bdbdbd",
  "#fa9fb5",
  "#bcbddc",
  "#addd8e",
  "#9ecae1",
  "#a1d99b",
];

function Dashboard() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(weekday[new Date().getDay()]);

  const [isLoading, setIsLoading] = useState(true);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDay(weekday[date.getDay()]);
  };

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "HOME"
  );

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  const state = useSelector((state) => state);
  const [studentLeaveRequests, setStudentLeaveRequests] = useState([]);

  const [eventsList, setEventsList] = useState([]);
  const [eventsDateList, setEventsDateList] = useState([]);
  const [exams, setExams] = useState([]);

  const [rankersList, setRankersList] = useState([]);

  const [importantDatesList, setImportantDatesList] = useState([]);
  const [importantDatesDateList, setImportantDatesDateList] = useState([]);

  const [holidayList, setHolidayList] = useState([]);
  const [holidayDateList, setHolidayDateList] = useState([]);

  const [examDateList, setExamDateList] = useState([]);

  const [timeTable, setTimeTable] = useState([]);
  const [noticeBoard, setNoticeBoard] = useState({});
  const [chartX, setChartX] = useState([]);
  const [chartY, setChartY] = useState([]);

  const graph = {
    dataLine: {
      labels: chartY,
      datasets: [
        {
          label: "Holistic ranking",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: "#ff3333",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ff3333",
          pointBackgroundColor: "#ff3333",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ff3333",
          pointHoverBorderColor: "#ff3333",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: chartX,
        },
      ],
    },
  };

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.student.institution_id;
    body = JSON.stringify(body);
    axios.post(API_URL + "/get_events_list", body, config).then((res) => {
      var tempEventsList = res.data["events_list"];
      var tempHolidayList = res.data["holidays_list"];
      var tempImportantDatesList = res.data["important_dates_list"];

      var tempEventsDateList = [];
      for (var i = 0; i < res.data["events_list"].length; i++) {
        tempEventsDateList.push(res.data["events_list"][i]["date"]);
      }
      setEventsDateList(tempEventsDateList);

      var tempHolidayDateList = [];
      for (var i = 0; i < res.data["holidays_list"].length; i++) {
        tempHolidayDateList.push(res.data["holidays_list"][i]["date"]);
      }
      setHolidayDateList(tempHolidayDateList);

      var tempImportantDatesDateList = [];
      for (var i = 0; i < res.data["important_dates_list"].length; i++) {
        tempImportantDatesDateList.push(
          res.data["important_dates_list"][i]["date"]
        );
      }
      setImportantDatesDateList(tempImportantDatesDateList);

      for (var i = res.data["events_list"].length - 1; i >= 0; i--) {
        if (
          moment(res.data["events_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment()
          )
        ) {
          tempEventsList.splice(i, 1);
        }
      }

      setEventsList(tempEventsList);

      for (var i = res.data["holidays_list"].length - 1; i >= 0; i--) {
        if (
          moment(res.data["holidays_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment()
          )
        ) {
          tempHolidayList.splice(i, 1);
        }
      }

      setHolidayList(tempHolidayList);

      for (var i = res.data["important_dates_list"].length - 1; i >= 0; i--) {
        if (
          moment(
            res.data["important_dates_list"][i]["date"],
            "DD-MM-YYYY"
          ).isBefore(moment())
        ) {
          tempImportantDatesList.splice(i, 1);
        }
      }

      setImportantDatesList(tempImportantDatesList);
      var body = {};
      body["institution_id"] = state.auth.student.institution_id;
      body["class_id"] = state.auth.student.class_id;
      body["division"] = state.auth.student.division;
      body = JSON.stringify(body);
      axios
        .post(API_URL + "/get_student_time_table", body, config)
        .then((res) => {
          setTimeTable(res.data);
          axios.post(API_URL + "/get_exams", body, config).then((res) => {
            var tempExamDateList = [];
            var tempExamList = [];
            for (var i = 0; i < res.data.length; i++) {
              if (
                !res.data[i]["completed"] &&
                moment(res.data[i]["start_date"], "DD-MM-YYYY").isAfter(
                  moment()
                )
              ) {
                tempExamList.push(res.data[i]);
              }
            }
            for (var i = 0; i < tempExamList.length; i++) {
              for (var j = 0; j < tempExamList[i]["subjects"].length; j++) {
                var tempSub = tempExamList[i]["subjects"][j];
                tempExamDateList.push(tempSub[Object.keys(tempSub)[0]]["date"]);
              }
            }
            var studentpending = 0;
            var studentapproved = 0;
            var studentrejected = 0;
            var lr = JSON.parse(state.auth.student["leave_requests"]);
            for (var i = 0; i < lr.length; i++) {
              if (lr[i]["status"] == "PENDING") {
                studentpending += 1;
              } else if (lr[i]["status"] == "APPROVED") {
                studentapproved += 1;
              } else if (lr[i]["status"] == "REJECTED") {
                studentrejected += 1;
              }
            }
            setStudentLeaveRequests({
              PENDING: studentpending,
              APPROVED: studentapproved,
              REJECTED: studentrejected,
            });
            setExams(tempExamList);
            setExamDateList(tempExamDateList);
            axios
              .post(API_URL + "/get_noticeboard_student", body, config)
              .then((res) => {
                setNoticeBoard(res.data);
                setIsLoading(false);
              });
          });
        })
        .catch((err) => {});
    });
  }

  function getContent() {
    if (selectedPage == "HOME") {
      return (
        <Grid container spacing={2}>
          <Grid item md={3}>
            <h3 style={{ fontWeight: "bold" }}>Timetable</h3>
            {Object.keys(timeTable).length != 0 ? (
              <div style={{ marginTop: "-11px" }}>
                {timeTable[selectedDay] == "" ? (
                  <Box
                    borderRadius="15px"
                    style={{
                      backgroundColor: colorList[0],
                      borderBottom: "4px solid " + colorList2[colorIndex],
                      width: "100%",
                      padding: "2px",
                      height: "85vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      backgroundImage:
                        "linear-gradient(to right, rgba(251,237,217, 0.9), rgba(251,237,217, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                    }}
                  >
                    <Fab
                      size="large"
                      style={{
                        height: "100px",
                        width: "100px",
                        border: "5px solid #31a354",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      }}
                      aria-label="add"
                    >
                      <CheckIcon
                        style={{
                          color: "#31a354",
                          fontSize: "75px",
                        }}
                      />
                    </Fab>
                    <h4 style={{ color: "black" }}>
                      No{" "}
                      {state.auth.classType == "STANDARDS"
                        ? " classes "
                        : " lectures "}{" "}
                      today!
                    </h4>
                    <div
                      style={{
                        margin: "-20px 0px 0px 12px",
                        color: "grey",
                        fontSize: "15px",
                      }}
                    >
                      There are no{" "}
                      {state.auth.classType == "STANDARDS"
                        ? " classes "
                        : " lectures "}{" "}
                      scheduled for today
                    </div>
                  </Box>
                ) : (
                  <Fragment>
                    {timeTable[selectedDay].map((lecture, index) => (
                      <div style={{ marginBottom: "15px" }}>
                        <Grid
                          container
                          spacing={0}
                          justifyContent="flex-start"
                          alignItems="center"
                        >
                          <Grid item md={12}>
                            <Box
                              borderRadius="10px"
                              style={
                                lecture["subject"]
                                  .toLowerCase()
                                  .includes("break") ||
                                lecture["subject"]
                                  .toLowerCase()
                                  .includes("lunch")
                                  ? {
                                      border: "1.5px solid grey",
                                      padding: "2px",
                                      display: "flex",
                                    }
                                  : {
                                      padding: "2px",
                                      display: "flex",
                                      backgroundColor: colorList[index],
                                    }
                              }
                            >
                              <div
                                style={{
                                  margin:
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("break") ||
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("lunch")
                                      ? "4px 0px 0px 8px"
                                      : "6px 0px 0px 8px",
                                  color: colorList2[colorIndex],
                                }}
                              >
                                {getIcon(lecture["subject"])}
                              </div>
                              <div>
                                <div
                                  style={{
                                    fontWeight: "600",
                                    letterSspacing: "2px",
                                    margin:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "1px 0px 0px 12px"
                                        : "3px 0px 0px 12px",
                                    color:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "black"
                                        : colorList2[colorIndex],
                                    fontSize: "20px",
                                  }}
                                >
                                  {lecture["subject"]}
                                </div>
                                <div
                                  style={{
                                    margin: "-3px 0px 0px 12px",
                                    color:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "black"
                                        : colorList2[colorIndex],
                                    fontSize: "15px",
                                  }}
                                >
                                  {lecture["time"]}
                                </div>
                              </div>
                            </Box>
                          </Grid>
                        </Grid>
                      </div>
                    ))}
                  </Fragment>
                )}
                <br></br>
              </div>
            ) : (
              ""
            )}
          </Grid>
          <Grid item md={3}>
            <h3 style={{ fontWeight: "bold" }}>Calendar</h3>
            <div style={{ marginTop: "-35px", marginBottom: "15px" }}>
              <Box
                borderRadius="15px"
                style={{
                  backgroundColor: colorList[0],
                  marginTop: "40px",
                }}
              >
                <div className="calendar-container">
                  <Calendar
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                    }}
                    onChange={handleDateChange}
                    value={selectedDate}
                    tileClassName={({ date, view }) => {
                      if (
                        eventsDateList.find(
                          (x) => x === moment(date).format("DD-MM-YYYY")
                        )
                      ) {
                        return "highlightEvent";
                      } else if (
                        holidayDateList.find(
                          (x) => x === moment(date).format("DD-MM-YYYY")
                        )
                      ) {
                        return "highlightHoliday";
                      } else if (
                        importantDatesDateList.find(
                          (x) => x === moment(date).format("DD-MM-YYYY")
                        )
                      ) {
                        return "highlightImportant";
                      } else if (
                        examDateList.find(
                          (x) => x === moment(date).format("DD-MM-YYYY")
                        )
                      ) {
                        return "highlightExam";
                      } else if (date.getDay() == 6) {
                        return "highlightSaturday";
                      }
                    }}
                  />
                </div>
              </Box>
              <div
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                  padding: 12,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    marginRight: "4px",
                    color: "white",
                    fontSize: "13px",
                    backgroundColor: "#6a6fff",
                    padding: "5px",
                    borderRadius: "20px",
                  }}
                >
                  {" "}
                  Assignment
                </span>
                <span
                  style={{
                    marginRight: "4px",
                    color: "white",
                    fontSize: "13px",
                    backgroundColor: "#a1d99b",
                    padding: "5px",
                    borderRadius: "20px",
                  }}
                >
                  {" "}
                  Exam
                </span>

                <span
                  style={{
                    marginRight: "4px",
                    color: "white",
                    fontSize: "13px",
                    backgroundColor: "#ff3333",
                    padding: "5px",
                    borderRadius: "20px",
                  }}
                >
                  {" "}
                  Holiday
                </span>

                <span
                  style={{
                    marginRight: "4px",
                    color: "white",
                    fontSize: "13px",
                    backgroundColor: "#fa9fb5",
                    padding: "5px",
                    borderRadius: "20px",
                  }}
                >
                  {" "}
                  Event
                </span>

                <span
                  style={{
                    marginRight: "4px",
                    color: "white",
                    fontSize: "13px",
                    backgroundColor: "#fdbb84",
                    padding: "5px",
                    borderRadius: "20px",
                  }}
                >
                  {" "}
                  Important
                </span>
              </div>
            </div>

            <div
              style={{
                marginTop: "-5px",
                padding: "15px",
                backgroundColor: themeStyle.primaryColorLight,
                borderRadius: "25px",
                height: "33vh",
              }}
            >
              {eventsList.length != 0 ? (
                <h4
                  style={{
                    margin: "-5px",
                    marginLeft: "5px",
                    fontWeight: "bold",
                    color: themeStyle.primaryColor,
                  }}
                >
                  Upcoming events
                </h4>
              ) : (
                <Fragment>
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <Box
                      borderRadius="15px"
                      style={{
                        backgroundColor: colorList[0],
                        borderBottom: "4px solid " + colorList2[colorIndex],
                        width: "100%",
                        padding: "2px",
                        height: "30vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundImage:
                          "linear-gradient(to right, rgba(251,237,217, 0.9), rgba(251,237,217, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <Fab
                          size="large"
                          style={{
                            border: "3px solid blue",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          }}
                          aria-label="add"
                        >
                          <PriorityHighIcon
                            style={{
                              color: themeStyle.primaryColor,
                            }}
                          />
                        </Fab>
                        <h4 style={{ color: "black" }}>No upcoming Events.</h4>
                        <div
                          style={{
                            color: "grey",
                            marginTop: "-25px",
                          }}
                        >
                          Click Here to go to events page.
                        </div>
                      </div>
                    </Box>
                  </Link>
                </Fragment>
              )}

              <div style={{ marginTop: "15px" }}>
                {eventsList.slice(0, 2).map((event, index) => (
                  <Link
                    to="/events"
                    path
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <CardActionArea
                      style={{
                        height: "80px",
                        backgroundColor: colorList2[index],
                        borderRadius: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid
                          item
                          md={8}
                          style={{
                            marginTop: "-3px",
                            marginLeft: "5px",
                          }}
                        >
                          <p
                            style={{
                              margin: "0px 0px 3px 10px",
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "white",
                            }}
                          >
                            {event["name"]}
                          </p>

                          <p
                            style={{
                              margin: "0px 0px 5px 10px",
                              fontSize: "13px",
                              color: "white",
                            }}
                          >
                            {moment(event["date"], "DD-MM-YYYY").format(
                              "Do MMMM, YYYY"
                            )}
                          </p>
                          <p
                            style={{
                              margin: "-3px 0px 0px 10px",
                              fontSize: "15px",
                              color: colorList3[colorIndex],
                            }}
                          >
                            {event["venue"]}
                          </p>
                        </Grid>
                        <Grid item>
                          <ChevronRightIcon
                            style={{
                              fontSize: "40px",
                              color: colorList3[colorIndex],
                            }}
                          />
                        </Grid>
                      </Grid>
                    </CardActionArea>
                  </Link>
                ))}
                <Link
                  to="/events"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      textAlign: "right",
                      color: themeStyle.primaryColor,
                    }}
                  >
                    <h4>More Events...</h4>
                  </div>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item md={3}>
            <h3 style={{ fontWeight: "bold" }}>Holistic Ranking</h3>
            <Box style={{ marginBottom: "-5px" }}>
              <Line
                height={350}
                width={350}
                data={graph.dataLine}
                options={{
                  responsive: true,
                  animation: { duration: 0 },
                }}
              />
            </Box>
            {exams.length != 0 ? (
              <h3 style={{ fontWeight: "bold" }}>Upcoming Examinations</h3>
            ) : (
              <Fragment>
                <h3>No Upcoming Examinations</h3>
                <Link
                  to="/events"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      backgroundColor: "#f0f3f7",
                      borderRadius: "15px",
                      alignItems: "center",
                      height: "35%",
                      borderBottom: "4px solid " + colorList2[colorIndex],
                      backgroundImage:
                        "linear-gradient(to right, rgba(215,236,255, 0.9), rgba(215,236,255, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <Fab
                        size="large"
                        style={{
                          height: "100px",
                          width: "100px",
                          border: "5px solid #31a354",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        }}
                        aria-label="add"
                      >
                        <CheckIcon
                          style={{
                            color: "#31a354",
                            fontSize: "75px",
                          }}
                        />
                      </Fab>
                      <h4 style={{ color: "black" }}>
                        No upcoming Examinations.
                      </h4>
                      <div
                        style={{
                          color: "grey",
                          marginTop: "-25px",
                        }}
                      >
                        Click Here to go to events page.
                      </div>
                    </div>
                  </div>
                </Link>
              </Fragment>
            )}{" "}
            <div style={{ marginTop: "-5px" }}>
              {exams.slice(0, 4).map((exam, index) => (
                <Link to="/exams" style={{ textDecoration: "none" }}>
                  <CardActionArea
                    fullWidth
                    style={{
                      borderRadius: "15px",
                      padding: "12px 10px 10px 8px",
                      backgroundColor: colorList[index],
                      marginBottom: "15px",
                    }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid
                        item
                        md={8}
                        style={{
                          marginTop: "-3px",
                          marginLeft: "5px",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "2px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: colorList2[colorIndex],
                          }}
                        >
                          {exam["test"]}
                        </div>

                        <span
                          style={{
                            fontSize: "13px",

                            color: "black",
                          }}
                        >
                          {moment(exam["start_date"], "DD-MM-YYYY").format(
                            "Do MMMM, YYYY"
                          ) +
                            " - " +
                            moment(exam["end_date"], "DD-MM-YYYY").format(
                              "Do MMMM, YYYY"
                            )}
                        </span>
                      </Grid>
                      <Grid item>
                        <ChevronRightIcon
                          style={{
                            fontSize: "40px",
                            color: colorList3[colorIndex],
                          }}
                        />
                      </Grid>
                    </Grid>
                  </CardActionArea>
                </Link>
              ))}
            </div>
          </Grid>
          <Grid item md={3} style={{ width: "100%" }}>
            <h3 style={{ marginLeft: "15px", fontWeight: "bold" }}>
              Your Leave Requests
            </h3>
            <div
              style={{
                display: "flex",
                marginTop: "17px",
                justifyContent: "space-between",

                width: "100%",
              }}
            >
              <Link
                style={{
                  textDecoration: "none",
                  color: "black",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                to={{
                  pathname: "/leave_requests",
                  search: "?tab=TEACHERLEAVES",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#31a354",
                    color: "white",
                    boxShadow: "none",
                    height: "100px",
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "15px",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "50px",
                      marginTop: "30px",
                      textAlign: "center",
                    }}
                  >
                    {studentLeaveRequests["APPROVED"]}
                  </h1>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "15px",
                    marginTop: "10px",
                    color: "#31a354",

                    width: "100%",
                  }}
                >
                  APPROVED{" "}
                </div>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color: "black",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                to={{
                  pathname: "/leave_requests",
                  search: "?tab=TEACHERLEAVES",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ff3333",
                    color: "white",
                    boxShadow: "none",
                    height: "100px",
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "15px",
                  }}
                >
                  <h1 style={{ fontSize: "50px" }}>
                    {studentLeaveRequests["REJECTED"]}
                  </h1>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "15px",
                    marginTop: "10px",
                    color: "#ff3333",
                  }}
                >
                  REJECTED
                </div>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color: "black",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                to={{
                  pathname: "/leave_requests",
                  search: "?tab=TEACHERLEAVES",
                }}
              >
                <div
                  style={{
                    backgroundColor: themeStyle.primaryColor,
                    color: "white",
                    boxShadow: "none",
                    height: "100px",
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "15px",
                  }}
                >
                  <h1 style={{ fontSize: "50px" }}>
                    {studentLeaveRequests["PENDING"]}
                  </h1>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "15px",
                    marginTop: "10px",
                    color: themeStyle.primaryColor,
                  }}
                >
                  PENDING
                </div>
              </Link>
            </div>
            <div
              style={{
                margin: "20px",
                padding: "15px",
                backgroundColor: themeStyle.primaryColorLight,
                borderRadius: "25px",
                height: "32vh",
                marginRight: "5px",
                marginLeft: "-5px",
              }}
            >
              {importantDatesList.length != 0 ? (
                <h4
                  style={{
                    marginTop: "-5px",
                    marginLeft: "5px",
                    fontWeight: "bold",
                    color: themeStyle.primaryColor,
                    marginBottom: "-5px",
                  }}
                >
                  Important dates
                </h4>
              ) : (
                <Fragment>
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <div
                      style={{
                        margin: "20px",
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#dce1f7",
                        borderRadius: "15px",
                        alignItems: "center",
                        height: "95%",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <Fab
                          size="large"
                          style={{
                            border: "3px solid blue",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          }}
                          aria-label="add"
                        >
                          <PriorityHighIcon
                            style={{
                              color: "blue",
                            }}
                          />
                        </Fab>
                        <br />
                        <h4 style={{ color: "black" }}>
                          No upcoming important dates.
                        </h4>

                        <div
                          style={{
                            color: "grey",
                            marginTop: "-25px",
                          }}
                        >
                          Click Here to go to events page.
                        </div>
                      </div>
                    </div>
                  </Link>
                </Fragment>
              )}
              {importantDatesList.slice(0, 3).map((date, index) => (
                <Link
                  key={index}
                  to="/events"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <Box
                    border={1}
                    borderColor="#d2d2d2"
                    p={1}
                    fullWidth
                    borderRadius="16px"
                    style={{
                      display: "flex",
                      backgroundColor: colorList2[index],
                      color: "black",
                      justifyContent: "space-between",
                      marginTop: "15px",
                    }}
                    alignItems="center"
                  >
                    <p
                      style={{
                        fontSize: "15px",
                        margin: "-0px 0px 0px 12px",
                        width: "60%",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      {date["name"]}
                    </p>
                    <div
                      style={{
                        margin: "-3px 10px 0px 0px",
                        color: "black",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                      >
                        {moment(date["date"], "DD-MM-YYYY").format("Do MMM")}
                      </span>
                    </div>
                  </Box>
                </Link>
              ))}
            </div>
            <Link to="/support" style={{ textDecoration: "none" }}>
              <div
                style={{
                  marginTop: "25px",
                  height: "32vh",
                  borderRadius: "15px",
                  backgroundColor: themeStyle.secondaryColor,
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Need help? Feel free to contact us for support!
                </div>
                <Button
                  style={{
                    fontSize: "15px",
                    height: "35px",
                    marginTop: "10px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                  fullWidth
                  variant="contained"
                  component="span"
                >
                  <h4>Help Center</h4>
                </Button>
                <img
                  style={{
                    height: "20vh",
                    marginLeft: "30px",
                    marginTop: "-15px",
                  }}
                  src={require("../../img/support.png")}
                ></img>
              </div>
            </Link>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <div style={{ marginTop: "75px" }}>
          {Object.keys(noticeBoard).map((category) => (
            <Fragment>
              {noticeBoard[category].length != 0 ? (
                <Fragment>
                  <h2>
                    For {category.charAt(0).toUpperCase() + category.slice(1)}
                  </h2>
                  <Grid container spacing={1.5}>
                    {noticeBoard[category].map((noti, index) => (
                      <Grid item md={3}>
                        <Box
                          padding={1}
                          borderRadius="5px"
                          sx={{ "&:hover": { opacity: "1 !important" } }}
                          style={{
                            borderRadius: "15px",
                            backgroundColor: colorList[index],
                            boxShadow: "none",
                            height: "100%",
                            marginBottom: "5px",
                          }}
                        >
                          <Box style={{ marginLeft: "5px" }}>
                            <Grid
                              container
                              spacing={2}
                              justifyContent="space-between"
                            >
                              <Grid item md={10}>
                                <div
                                  style={{
                                    color: themeStyle.secondaryColor,
                                    fontSize: "19px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {noti["title"]}
                                </div>
                                <div
                                  style={{
                                    fontSize: "15px",
                                    color: "grey",
                                  }}
                                >
                                  {moment(noti["date"], "DD-MM-YYYY").format(
                                    "Do MMMM, YYYY"
                                  )}
                                </div>
                                <div
                                  style={{
                                    fontSize: "15px",
                                  }}
                                >
                                  {noti["venue"]}
                                </div>
                                <div
                                  style={{
                                    margin: "10px 0px 0px 0px",
                                    fontSize: "15px",
                                  }}
                                >
                                  {noti["desc"]}
                                </div>
                                {Object.keys(noti).includes("link") ? (
                                  <a
                                    href={noti["link"]}
                                    target="_blank"
                                    style={{
                                      margin: "10px 0px 0px 0px",
                                      fontSize: "15px",
                                    }}
                                    rel="noreferrer"
                                  >
                                    View Document
                                  </a>
                                ) : (
                                  ""
                                )}
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Fragment>
              ) : (
                <span>
                  <>
                    {category == "everyone" ||
                    category == "parents" ||
                    category == "students" ||
                    category == "teachers" ? (
                      <h3
                        style={{
                          color: "grey",
                          fontSize: 18,
                        }}
                      >
                        No Notice for {category}
                      </h3>
                    ) : (
                      <></>
                    )}
                  </>
                </span>
              )}
            </Fragment>
          ))}{" "}
        </div>
      );
    }
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
      if (
        Object.keys(JSON.parse(state.auth.student.rank_history)).length != 0
      ) {
        var tempRanking = JSON.parse(state.auth.student.rank_history);
        var tempChartX = [];
        var tempChartY = [];
        for (
          var i = 0;
          i < tempRanking[state.auth.current_year]["history"].length;
          i++
        ) {
          tempChartX.push(0);
          tempChartY.push(0);
          tempChartX.push(
            parseInt(
              tempRanking[state.auth.current_year]["history"][i]["points"]
            )
          );
          tempChartY.push(i + 1);
          setChartX(tempChartX);
          setChartY(tempChartY);
        }
      }
    }
  }, []);

  var colorIndex = 0;

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_parent) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "white",
                  marginTop: "46vh",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent={"flex-end"}>
                    <Grid item md={4}>
                      {selectedPage == "HOME" ? (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      {selectedPage == "NOTICEBOARD" ? (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <div
                style={{
                  margin: "47px 20px 0px 90px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Dashboard;
